module.exports = __webpack_public_path__ + "img/background.0346fcf0.jpg";